import { Component, OnInit, Input } from '@angular/core';
import { ImprovementPlanProcess } from '../../models/improvement-plan-process';


@Component({
  selector: 'process-achievement-details',
  templateUrl: './process-achievement-details.component.html',
  styleUrls: ['./process-achievement-details.component.scss'],
})
export class ProcessAchievementDetailsComponent implements OnInit {
  @Input() process: ImprovementPlanProcess;
  constructor() {}

  ngOnInit() {}
}
